<script setup lang="ts">
type Props = {
  isShown?: boolean;
  slideInContainerClass?: string;
};

const props = withDefaults(defineProps<Props>(), {
  isShown: false,
  slideInContainerClass: 'max-w-96',
});

const emit = defineEmits(['closeSlideIn']);

const slideIn = ref<HTMLElement>();
const layout = useLayout();

onClickOutside(slideIn, () => {
  if (props.isShown) {
    emit('closeSlideIn');
  }
});

watch(
  () => props.isShown,
  (newValue) => {
    layout.scrollLockEnabled = newValue;
  },
);
</script>

<template>
  <section
    v-show="isShown"
    class="fixed inset-0 z-50 size-full overflow-clip"
  >
    <Transition name="fade">
      <div
        v-show="isShown"
        class="fixed inset-0 size-full overflow-clip bg-black/50"
        @click="emit('closeSlideIn')"
      ></div>
    </Transition>

    <Transition name="slide-from-right">
      <aside
        v-show="isShown"
        ref="slideIn"
        class="absolute top-0 flex size-full flex-col items-center overflow-y-auto overflow-x-clip bg-gray-10 px-14 py-20 md-max:inset-0 lg:right-0 lg:w-1/3 lg:items-start xl:w-1/4"
      >
        <BaseIcon
          name="close"
          fill-color="var(--color-secondary)"
          class="absolute right-6 top-7 z-[51] cursor-pointer p-3"
          @click="emit('closeSlideIn')"
        />

        <div :class="slideInContainerClass">
          <slot></slot>
        </div>
      </aside>
    </Transition>
  </section>
</template>
